import moment from 'moment'


export function sortByDecendingTime_(getTimeFromObjFunc) {
    return (a, b) => moment(getTimeFromObjFunc(b)).diff(moment(getTimeFromObjFunc(a)));
}